export const APPS_THAT_NEED_AUTH = ['bmwyuc', 'mini']
